import React from "react";
import {observer} from "mobx-react";
import {OrbitComponent} from "../../../../../base-components/orbit-component/orbit-component";
import {CyClass} from "../../../../../../../common/cy-classes";
import {USSafeToPlayButtonBox} from "../boxes/us.safe-to-play.box";
import {USSafeToPlayContainerBox} from "../boxes/us.safe-to-play-container.box";
import {USSafeToPlayLabelBox} from "../boxes/us.safe-to-play-label.box";

export const USSafeToPlayComponent = observer(
    class USFlagComponent extends OrbitComponent {
        private _onClickHandler = async () => {
            this.services.analytics.sendOrbitUserFlowEvent("Navigation","Header", 'Icon_nj_flag_icon');
            await this.services.linksNavigation.openSafeToPlay();
        }
        render() {
            return (
                <USSafeToPlayContainerBox className={CyClass('cy-safe-to-play')} onClick={this._onClickHandler}>
                    <USSafeToPlayLabelBox>
                        {this.services.translation.translate('NJ_JERSEY_COUNTRY_NAME')}
                    </USSafeToPlayLabelBox>
                    <USSafeToPlayButtonBox />
                </USSafeToPlayContainerBox>
            );
        }
    }
);